<template>
  <div class="py-8">
    <v-app-bar flat color="transparent">
      <app-bar-nav-icon />
      <v-toolbar-title class="breadcrumbs d-flex align-center">
        <v-icon class="text-light-blue">{{ icons.arrowLeft }}</v-icon>
        <router-link class="text-decoration--none" :to="{ name: 'tradies' }"
          >Tradie</router-link
        >
      </v-toolbar-title>
    </v-app-bar>

    <div class="ma-4" v-if="form">
      <div class="display-2 font-weight-bold my-6 text-capitalize">
        {{ displayName }}
      </div>

      <div class="d-flex my-6">
        <v-tabs hide-slider class="user-info-tabs">
          <v-tab class="pa-0" v-for="(item, key) in tabItems" :key="key">{{
            item.tab
          }}</v-tab>

          <v-tab-item class="col-md-4 col-sm-12 col-xs-12 mt-6 pa-0">
            <v-alert
              dense
              outlined
              type="warning"
              color="orange darken-3"
              max-width="400px"
              v-if="!!isTradieBlocked"
            >
              This account is <strong>disabled</strong>.
            </v-alert>

            <avatar-form
              :user="tradie"
              @change="avatarChange"
              @avatarRemove="tradieAvatarRemoved"
              :avatarLoading="avatarLoading"
            />

            <v-form ref="form" v-if="form" class="tradie-form">
              <v-divider></v-divider>

              <h3 class="py-5 primary--text">Tradie Information</h3>

              <label class="text-field-label">Full Name</label>
              <v-text-field
                flat
                solo
                required
                class="mt-2"
                v-model="form.full_name"
                :error-messages="form.$getError('full_name')"
                :loading="loading"
              ></v-text-field>

              <label class="text-field-label">Email</label>
              <v-text-field
                flat
                solo
                required
                class="mt-2"
                v-model="form.email"
                :error-messages="form.$getError('email')"
                :loading="loading"
              >
                <v-tooltip slot="append" top v-if="tradie.email">
                  <template v-slot:activator="{ on }">
                    <v-icon
                      color="success"
                      v-on="on"
                      v-if="tradie.email_verified"
                      >{{ icons.check }}</v-icon
                    >
                    <v-icon color="warning" v-on="on" v-else>{{
                      icons.alert
                    }}</v-icon>
                  </template>
                  <span v-if="tradie.email_verified">Email Verified</span>
                  <span v-else>Unverified email</span>
                </v-tooltip>
              </v-text-field>

              <label class="text-field-label">Phone Number</label>
              <v-text-field
                flat
                solo
                required
                class="mt-2"
                v-model="form.phone_number"
                :error-messages="form.$getError('phone_number')"
                :loading="loading"
              >
                <v-tooltip slot="append" top v-if="tradie.phone_number">
                  <template v-slot:activator="{ on }">
                    <v-icon
                      color="success"
                      v-on="on"
                      v-if="tradie.phone_number_verified"
                      >{{ icons.check }}</v-icon
                    >
                    <v-icon color="warning" v-on="on" v-else>{{
                      icons.alert
                    }}</v-icon>
                  </template>
                  <span v-if="tradie.phone_verified"
                    >Phone Number Verified</span
                  >
                  <span v-else>Unverified Phone Number</span>
                </v-tooltip>
              </v-text-field>

              <label class="text-field-label">USI Number</label>
              <v-text-field
                flat
                solo
                required
                class="mt-2"
                v-model="form.usi"
                :error-messages="form.$getError('usi')"
                :loading="loading"
              >
              </v-text-field>

              <v-checkbox
                :input-value="isTradieBlocked"
                label="Disable tradie account"
                color="orange darken-3"
                class="mt-0"
                @mousedown="showModal = true"
              ></v-checkbox>

              <div class="mt-4">
                <v-btn
                  color="primary"
                  class="mr-4 px-6"
                  height="40px"
                  width="100%"
                  @click="updateTradieDetails"
                  :loading="form.$busy"
                  >Update</v-btn
                >
              </div>
            </v-form>

            <v-dialog v-model="deleteDialog" max-width="290">
              <v-card>
                <v-card-title class="headline">Delete ?</v-card-title>

                <v-card-text
                  >Are you sure you want to delete this tradie ?</v-card-text
                >

                <v-card-actions>
                  <v-spacer></v-spacer>

                  <v-btn
                    text
                    @click="deleteDialog = false"
                    :loading="form.$busy"
                    >Cancel</v-btn
                  >

                  <v-btn
                    color="red"
                    text
                    @click="deleteTradie"
                    :loading="form.$busy"
                    >Yes, Delete please</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-tab-item>

          <v-tab-item><FileCards :id="tradie.id"/></v-tab-item>
        </v-tabs>

        <!-- <v-tabs hide-slider class="user-info-tabs">
          <v-tab class="pa-0" v-for="(item, key) in tabItems" :key="key">
            {{ item.tab }}
          </v-tab>

          <v-tab-item class="col-md-4 col-sm-12 col-xs-12 mt-6 pa-0">
            <v-alert
              dense
              outlined
              type="warning"
              color="orange darken-3"
              max-width="400px"
              v-if="!!isTradieBlocked"
            >
              This account is <strong>disabled</strong>.
            </v-alert>

            <avatar-form
              :user="tradie"
              @change="avatarChange"
              @avatarRemove="tradieAvatarRemoved"
              :avatarLoading="avatarLoading"
            />

            <v-form ref="form" v-if="form" class="tradie-form">
              <v-divider></v-divider>

              <h3 class="py-5 primary--text">Tradie Information</h3>

              <label class="text-field-label">Full Name</label>
              <v-text-field
                flat
                solo
                required
                class="mt-2"
                v-model="form.full_name"
                :error-messages="form.$getError('full_name')"
                :loading="loading"
              ></v-text-field>

              <label class="text-field-label">Email</label>
              <v-text-field
                flat
                solo
                required
                class="mt-2"
                v-model="form.email"
                :error-messages="form.$getError('email')"
                :loading="loading"
              >
                <v-tooltip slot="append" top v-if="tradie.email">
                  <template v-slot:activator="{ on }">
                    <v-icon
                      color="success"
                      v-on="on"
                      v-if="tradie.email_verified"
                      >{{ icons.check }}</v-icon
                    >
                    <v-icon color="warning" v-on="on" v-else>{{
                      icons.alert
                    }}</v-icon>
                  </template>
                  <span v-if="tradie.email_verified">Email Verified</span>
                  <span v-else>Unverified email</span>
                </v-tooltip>
              </v-text-field>

              <label class="text-field-label">Phone number</label>
              <v-text-field
                flat
                solo
                required
                class="mt-2"
                v-model="form.phone_number"
                :error-messages="form.$getError('phone_number')"
                :loading="loading"
              >
                <v-tooltip slot="append" top v-if="tradie.phone_number">
                  <template v-slot:activator="{ on }">
                    <v-icon
                      color="success"
                      v-on="on"
                      v-if="tradie.phone_number_verified"
                      >{{ icons.check }}</v-icon
                    >
                    <v-icon color="warning" v-on="on" v-else>{{
                      icons.alert
                    }}</v-icon>
                  </template>
                  <span v-if="tradie.phone_verified"
                    >Phone Number Verified</span
                  >
                  <span v-else>Unverified Phone Number</span>
                </v-tooltip>
              </v-text-field>
              <v-checkbox
                :input-value="isTradieBlocked"
                label="Disable tradie account"
                color="orange darken-3"
                class="mt-0"
                @mousedown="showModal = true"
              ></v-checkbox>

              <div class="mt-4">
                <v-btn
                  color="primary"
                  class="mr-4 px-6"
                  height="40px"
                  width="100%"
                  @click="updateTradieDetails"
                  :loading="form.$busy"
                  >Update</v-btn
                >
              </div>
            </v-form>

            <v-dialog v-model="deleteDialog" max-width="290">
              <v-card>
                <v-card-title class="headline">Delete ?</v-card-title>

                <v-card-text
                  >Are you sure you want to delete this tradie ?</v-card-text
                >

                <v-card-actions>
                  <v-spacer></v-spacer>

                  <v-btn
                    text
                    @click="deleteDialog = false"
                    :loading="form.$busy"
                    >Cancel</v-btn
                  >

                  <v-btn
                    color="red"
                    text
                    @click="deleteTradie"
                    :loading="form.$busy"
                    >Yes, Delete please</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-tab-item>

          <v-tab-item class="col-md-4 col-sm-12 col-xs-12 mt-6 pa-0"
            >Chats</v-tab-item
          >
        </v-tabs> -->
      </div>
    </div>

    <!-- <test-notifications v-if="tradie" class="pa-4" :user="tradie" /> -->

    <v-overlay absolute :value="loading" opacity="0.2">
      <v-progress-circular
        indeterminate
        color="primary"
        size="64"
      ></v-progress-circular>
    </v-overlay>
    <v-snackbar v-model="snackbar.show" right :color="snackbar.color">
      {{ snackbar.message }}
      <v-btn text @click="snackbar.show = false">OK</v-btn>
    </v-snackbar>

    <ConfirmModal
      v-model="showModal"
      title="Disable Account"
      :message="disableMessage"
      @cancel="showModal = false"
      @confirm="blockAccount"
    ></ConfirmModal>
  </div>
</template>

<script>
import { mdiChevronLeft, mdiCheck, mdiAlertCircleOutline } from '@mdi/js'
import { mapState, mapActions, mapMutations } from 'vuex'
import AppBarNavIcon from '@/layouts/shared/AppBarNavIcon'
import AvatarForm from './../components/AvatarForm'
// import TestNotifications from '@/components/TestNotifications'
import ConfirmModal from '@/components/modals/ConfirmModal'
import FileCards from './../components/FileCards'

import Form from '@/utils/form'

export default {
  name: 'TradieDetails',

  components: {
    AvatarForm,
    AppBarNavIcon,
    // TestNotifications,
    ConfirmModal,
    FileCards
  },

  data() {
    return {
      icons: {
        arrowLeft: mdiChevronLeft,
        check: mdiCheck,
        alert: mdiAlertCircleOutline
      },
      loading: false,
      avatarLoading: false,
      deleteDialog: false,
      form: null,
      showCropperModal: false,
      avatarTimestamp: new Date().getTime(),
      snackbar: {
        show: false,
        message: null,
        color: ''
      },
      showModal: false,
      tabItems: [{ tab: 'Info' }, { tab: 'Files' }]
    }
  },

  computed: {
    ...mapState({
      tradie: state => state.tradies.tradieDetails,
      authUser: state => state.auth.user
    }),
    displayName() {
      return this.form.full_name || this.form.email
    },
    tradieBlockedAction() {
      return this.tradie
        ? this.tradie.blocked_at
          ? 'unblocked'
          : 'blocked'
        : 'unblocked'
    },
    isTradieBlocked() {
      return this.tradie
        ? this.tradie.blocked_at
          ? this.tradie.blocked_at
          : null
        : null
    },
    disableMessage() {
      const action = this.tradieBlockedAction
      return `Are you sure you want ${action} this account?`
    }
  },

  methods: {
    ...mapActions({
      getTradieDetails: 'tradies/getTradieDetails',
      changeAvatar: 'tradies/changeAvatar',
      updateTradie: 'tradies/updateTradie',
      blockTradie: 'tradies/blockTradie'
    }),

    ...mapMutations({
      clearTradieDetails: 'tradies/clearTradieDetails',
      setSelectedTradieAvatar: 'tradies/setSelectedTradieAvatar',
      tradieAvatarRemoved: 'tradies/tradieAvatarRemoved',
      clearFileList: 'file/clearFileList'
    }),

    async getTradie() {
      this.loading = true
      await this.getTradieDetails(this.$route.params.id)
      this.form = new Form(this.tradie)
      this.loading = false
    },

    async avatarChange(image) {
      this.avatarLoading = true
      let data = new FormData()
      data.append('user_id', this.tradie.id)
      data.append('avatar', image)
      await this.changeAvatar(data)
      this.avatarLoading = false
      this.showSnackbar('Avatar successfully updated!', 'success')
    },

    async updateTradieDetails() {
      this.form.$busy = true
      this.form.$clearErrors()
      this.updateTradie(this.form.$data())
        .then(() => {
          this.form.$busy = false
          this.showSnackbar('Tradie details successfully updated!', 'success')
        })
        .catch(err => {
          this.form.$busy = false
          if (err.response.status === 422) {
            this.form.$setErrors(err.response.data.errors)
          }
        })
    },

    deleteTradie() {
      this.form.$busy = true
      this.tradie.delete().then(() => {
        this.form.$busy = false
        this.deleteDialog = false
        this.showSnackbar('Tradie deleted successfully!')
        this.$router.replace('/users/tradie')
      })
    },

    showSnackbar(message, color) {
      this.snackbar.message = message
      this.snackbar.show = true
      this.snackbar.color = color
    },
    blockAccount(value) {
      this.form.$busy = true
      const action = this.tradieBlockedAction
      this.blockTradie({
        id: this.tradie.id,
        action
      })
        .then(() => {
          this.form.$busy = false
          this.showModal = false
          this.showSnackbar(`Tradie successfully ${action}!`, 'success')
        })
        .catch(err => {
          this.form.$busy = false
          if (err.response.status === 422) {
            this.form.$setErrors(err.response.data.errors)
          }
        })
    }
  },

  created() {
    this.getTradie()
  },

  destroyed() {
    this.clearTradieDetails()
    this.clearFileList()
  },

  watch: {
    $route() {
      this.getTradie()
    }
  }
}
</script>

<style lang="scss" scoped>
.tradie-form {
  width: 400px;

  @media (max-width: 420px) {
    width: 100%;
  }
}
</style>
